import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ToastProvider } from './ToastContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { installErrorReporting } from './monitoring';
import './index.css';

installErrorReporting();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ToastProvider>
      <App />
    </ToastProvider>
  </React.StrictMode>
);

// Offline app shell — lets the app open with no signal (see service-worker.js).
serviceWorkerRegistration.register();
